import { data } from "alpinejs/src/datas"

const product_card = ({ product, variant }) => ({
  variants: null,
  selectedVariant: null,
  currentProduct: null,
  selectedVariantDimensions: null,
  optionRadios: null,
  optionAllRadios: null,
  unavailableVariants: null,
  unavailableOptionsValues: [],
  unavailableVariantsTitles: [],
  selectedOptionPosition: 0,
  selectedPlan: "subsave",
  hasSellingPlan: false,
  sellingPlanId: null,
  selectedVariantSaleAllocationPrice: null,
  isPlaying: false,
  selectedOptions: [],
  checkedRadios: [],
  init() {
    this.optionAllRadios = [...document.querySelectorAll("[data-options]")]
    this.checkedRadios = this.optionAllRadios.filter((option) => option.checked)
    if (this.checkedRadios.length) {
      this.checkedRadios.forEach((radio) => {
        this.selectedOptions.push(radio.value)
      })
    }

    this.currentProduct = product
    this.variants = product.variants
    this.selectedVariant = variant
  },
  getSelectedVariant(event, variant) {
    this.selectedVariant = this.variants.filter(
      (variant) =>
        variant.title.trim().toLowerCase() ===
        this.optionAllRadios
          .filter((radio) => {
            return radio.checked
          })
          .map((radio) => radio.value)
          .join(" / ")
          .trim()
          .toLowerCase()
    )[0]
    if (this.currentProduct.options.length > 1) {
      this.setAvailableVariants(event)
    }
  },
  setAvailableVariants(event) {
    this.selectedOptionPosition = event.target.getAttribute(
      "data-option-position"
    )
    /*this.selectedOptions[this.selectedOptionPosition] = event.target.value*/
    this.unavailableVariants = this.variants
      .filter(
        (variant) =>
          variant.options[this.selectedOptionPosition] === event.target.value
      )
      .filter((variant) => !variant.available)

    this.unavailableOptionsValues = []
    this.optionAllRadios.forEach((radio) => {
      radio.classList.remove("disabled")
    })

    if (this.unavailableVariants.length) {
      this.unavailableVariants.forEach((variant) => {
        variant.options.forEach((option) => {
          if (event.target.value !== option) {
            this.unavailableOptionsValues.push(option)
          }
        })
      })

      if (this.unavailableOptionsValues.length) {
        this.unavailableOptionsValues.forEach((value) => {
          if (
            this.optionAllRadios.filter((radio) => radio.value === value).length
          ) {
            this.optionAllRadios
              .filter((radio) => radio.value === value)
              .forEach((radio) => {
                radio.classList.add("disabled")
              })
          }
        })
      }
    }

    /*this.selectedOptionPosition = this.selectedVariant.options.indexOf(event.target.value) + 1
    this.unavailableOptionsValues = []
    this.unavailableVariantsTitles = []
    const optionsList = [...document.querySelectorAll(`.options-list`)]
    const notSelectedOptionsList = optionsList.filter(list => +list.getAttribute("data-option-position") !== this.selectedOptionPosition)

    this.unavailableVariants = this.variants.filter((variant) => variant.options.includes(event.target.value)).filter((variant) => !variant.available)
    notSelectedOptionsList.forEach((option, index) => {
        this.optionRadios = option.querySelectorAll("[data-product-variants]")
    })

    this.optionRadios.forEach((radio) => {
        /!*radio.disabled = false*!/
        radio.classList.remove("disabled")
    })

    if (this.unavailableVariants.length > 0) {
        this.unavailableVariants.forEach((variant) => {
            if (!this.unavailableVariantsTitles.includes(variant.title)) {
                this.unavailableVariantsTitles.push(variant.title)
            }
            variant.options.forEach((option) => {
                if (!this.unavailableOptionsValues.includes(option)) {
                    this.unavailableOptionsValues.push(option)
                }
            })
        })
    }

    if (this.unavailableOptionsValues.length > 0) {
        this.unavailableOptionsValues.forEach((value) => {
            this.optionRadios.forEach((radio) => {
                if (radio.value === value && value !== event.target.value) {
                    /!*radio.disabled = true*!/
                    radio.classList.add("disabled")
                }
            })
        })
    }*/
  },
  incrementQty(event) {
    Alpine.store("cart").qty++
  },
  decrementQty(event) {
    if (Alpine.store("cart").qty > 1) {
      Alpine.store("cart").qty--
    }
  }, 
  changeSellingPlan(event) {
    this.sellingPlanId = event.target.value
    if (
      this.selectedVariant.selling_plan_allocations.find(
        (item) => item.selling_plan_id == this.sellingPlanId
      )
    ) {
      this.selectedVariantSaleAllocationPrice =
        this.selectedVariant.selling_plan_allocations.find(
          (item) => item.selling_plan_id == this.sellingPlanId
        ).price
    }
  },
  switchSubscription(event) {
    this.selectedPlan = event.target.value
  },
})

export default product_card

window.addEventListener("alpine:init", () => {
  Alpine.data("ProductCard", product_card)
})
